import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

// material-ui components
import withStyles from "material-ui/styles/withStyles";
import AppBar from "material-ui/AppBar";
import Toolbar from "material-ui/Toolbar";
import IconButton from "material-ui/IconButton";
import Button from "material-ui/Button";
import Hidden from "material-ui/Hidden";

// material-ui icons
import Menu from "material-ui-icons/Menu";
import MoreVert from "material-ui-icons/MoreVert";
import ViewList from "material-ui-icons/ViewList";

// core components
import HeaderLinks from "./HeaderLinks";
import CustomIconButton from "components/CustomButtons/IconButton.jsx";

import headerStyle from "assets/jss/material-dashboard-pro-react/components/headerStyle.jsx";

function Header({ ...props }) {

  function makeBrand() {
    var name;
    props.routes && props.routes.map((prop, key) => {
      if (prop.path === props.location.pathname) {
        name = prop.name;
      } else if (prop.path.endsWith('/:id')) {
        if (props.location.pathname.startsWith('/agenti')) {
          name = "Dettaglio Agenti";
        } else if (props.location.pathname.startsWith('/clienti')) {
          name = "Dettaglio Clienti";
        } else if (props.location.pathname.startsWith('/non-risposto')) {
          name = "Clienti che non hanno risposto";
        } else if (props.location.pathname.startsWith('/nuovo-cliente')) {
          name = "Nuovo Cliente";
        } else if (props.location.pathname.startsWith('/lock')) {
          name = "Lock Screen";
        }
      }
      return null;
    });
    return name;
  }

  const { classes, color, rtlActive } = props;

  const appBarClasses = cx({
    [" " + classes[color]]: color
  });

  const sidebarMinimize =
    classes.sidebarMinimize +
    " " +
    cx({
      [classes.sidebarMinimizeRTL]: rtlActive
    });


  return (
    <AppBar className={classes.appBar + appBarClasses}>
      <Toolbar className={classes.container}>
        <Hidden smDown>
          <div className={sidebarMinimize}>
            {props.miniActive ? (
              <CustomIconButton color="white" onClick={props.sidebarMinimize}>
                <ViewList className={classes.sidebarMiniIcon} />
              </CustomIconButton>
            ) : (
              <CustomIconButton color="white" onClick={props.sidebarMinimize}>
                <MoreVert className={classes.sidebarMiniIcon} />
              </CustomIconButton>
            )}
          </div>
        </Hidden>
        <div className={classes.flex}>
          {/* Here we create navbar brand, based on route name */}
          <Button className={classes.title}>
            {makeBrand()}
          </Button>
        </div>
        <Hidden smDown implementation="css">
          <HeaderLinks />
        </Hidden>
        <Hidden mdUp>
          <IconButton
            className={classes.appResponsive}
            color="inherit"
            aria-label="open drawer"
            onClick={props.handleDrawerToggle}
          >
            <Menu />
          </IconButton>
        </Hidden>
      </Toolbar>
    </AppBar>
  );
}

Header.propTypes = {
  classes: PropTypes.object.isRequired,
  color: PropTypes.oneOf(["primary", "info", "success", "warning", "danger"]),
  rtlActive: PropTypes.bool
};

export default withStyles(headerStyle)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/Header.jsx